module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgdmlld0JveD0iMCAwIDMyIDMyIj4KICAgIDxwYXRoIGQ9Ik00IDE2YzAtNi42IDUuNC0xMiAxMi0xMnMxMiA1LjQgMTIgMTJjMCAxLjItMC44IDItMiAycy0yLTAuOC0yLTJjMC00LjQtMy42LTgtOC04cy04IDMuNi04IDggMy42IDggOCA4YzEuMiAwIDIgMC44IDIgMnMtMC44IDItMiAyYy02LjYgMC0xMi01LjQtMTItMTJ6Ij48L3BhdGg+Cjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/aplayer/assets/loading.svg
// module id = wkYA
// module chunks = 30